angular.module('galilai.creator').controller('VisualActionsController', function ($scope, $rootScope) {

    const BASE_STATE = {
        reorderPages: [],
        copyPages: [],
        copy: {
            layout: true,
            image: false,
            overlays: false,
        },
        copyTarget: 'all',
        reorderMap: [],
    }
    $scope.inputs = JSON.parse(JSON.stringify(BASE_STATE))
    $scope.onResult = null

    $rootScope.$on('visual.actions.show', function (event, data) {
        $scope.inputs = JSON.parse(JSON.stringify(BASE_STATE))
        let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('visual-action-modal'), {
            backdrop: 'static',
            keyboard: false
        })

        $scope.mode = data.mode
        $scope.onResult = data.onResult || null
        modal.show()

        if ($scope.mode == 'reorder') {
            $scope.inputs.reorderPages = data.pages.map((page, index) => {
                return {
                    _originalIndex: index,
                    text: page,
                }
            })
        }
        if ($scope.mode == 'copyPaste') {
            $scope.inputs.copyPages = data.pages.map((page, index) => {
                return {
                    disabled: index == data.sourceIndex,
                    selected: false,
                    text: page,
                }
            })
        }
    })

    $scope.onReorder = function (map) {
        $scope.inputs.reorderMap = map
    }

    function hideModal() {
        let modal = bootstrap.Modal.getInstance(document.getElementById('visual-action-modal'))
        if (modal) {
            modal.hide()
        }
    }

    $scope.confirm = function () {
        if ($scope.mode == 'reorder') {
            showConfirm(gettext('label.are_you_sure'), null, function(status) {
                if (status) {
                    if ($scope.onResult) {
                        $scope.onResult($scope.inputs.reorderMap)
                    }
                    hideModal()
                }
            })
        }
        if ($scope.mode == 'copyPaste') {
            let targetPages = []
            if ($scope.inputs.copyTarget === 'all') {
                targetPages = $scope.inputs.copyPages.map((page, index) => index)
            } else {
                targetPages = $scope.inputs.copyPages
                    .map((page, index) => page.selected ? index : -1)
                    .filter(index => index >= 0)
            }
            showConfirm(gettext('label.are_you_sure'), null, function(status) {
                if (status) {
                    if ($scope.onResult) {
                        $scope.onResult({
                            targetPages: targetPages,
                            copy: {
                                layout: $scope.inputs.copy.layout,
                                image: $scope.inputs.copy.image,
                                overlays: $scope.inputs.copy.overlays,
                            }
                        })
                    }
                    hideModal()
                }
            })
        }
    }
})
